import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { SbBaseFieldComponent } from '../sb-base-field.component';

@Component({
  selector: 'sb-currency-field',
  templateUrl: './sb-currency-field.component.html',
  styleUrls: ['./sb-currency-field.component.scss']
})
export class SbCurrencyFieldComponent extends SbBaseFieldComponent
  implements OnInit {
  @HostBinding('class') class: string = 'sb-currency-field';

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
